import Vue from 'vue'
import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";
import VueRouter from 'vue-router'
import { SET_LOGGED_IN, SET_ROUTER_ENTER } from "@/store/mutations.type"
import store from "@/store";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login',
    meta: { 
      requiresAuth: false,
    }
  },  
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login/Login.vue'),
    meta: { 
      requiresAuth: false
    }
  }, 
  {
    path: '/microsoft-auth/callback',
    name: 'microsoft-auth/callback',
    component: () => import('../views/Login/MicrosoftLogin.vue'),
    meta: { 
      requiresAuth: false
    }
  }, 
  {
    path: '/reset-password/',
    name: 'resetpassword',
    component: () => import('../views/Login/ResetPassword.vue'),
    meta: { 
      requiresAuth: false
    }
  },  
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/Dashboard/Dashboard.vue'),  
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,6]
    }
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('../views/Calendar/Calendar.vue'),  
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,6]
    }
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/Users/Users.vue'), 
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      allowedPermissions:['can-assign-custom-role','can-audit-user-history']
    }  
  }, 
  {
    path: '/ext-users',
    name: 'extusers',
    component: () => import('../views/Users/extUsers.vue'), 
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3]
    }  
  }, 
  {
    path: '/inbox',
    name: 'inbox',
    component: () => import('../views/Inbox/Inbox.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4],
      is_group_user: true,
      has_inbox: true
    }
  },   
  {
    path: '/inbox/:id',
    name: 'viewMessage',
    component: () => import('../views/Inbox/viewMessages.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4],
      is_group_user: true,
      has_inbox: true
    }  
  },
  {
    path: '/equipment',
    name: 'equipment',
    component: () => import('../views/Equipments/Equipments.vue'),   
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      has_equip_db: true,
      allowedPermissions:['can-create-equipment','can-update-equipment', 'can-delete-equipment']
    }
  },  
  {
    path: '/equipment/add',
    name: 'addequipment',
    component: () => import('../views/Equipments/addeditEquipments.vue'),   
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      has_equip_db: true,
      allowedPermissions:['can-create-equipment']
    }
  }, 
  {
    path: '/equipment/edit/:id',
    name: 'editequipment',
    component: () => import('../views/Equipments/addeditEquipments.vue'),  
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      has_equip_db: true,
      allowedPermissions:['can-update-equipment']
    }
  },      
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Login/Register.vue'),  
    meta: { 
      requiresAuth: false
    } 
  },   
  {
    path: '/groups',
    name: 'groups',
    component: () => import('../views/Groups/Groups.vue'),  
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['can-create-group','can-update-group', 'can-delete-group']
    } 
  },   
  {
    path: '/groups/edit/:id',
    name: 'editgroups',
    component: () => import('../views/Groups/addeditGroups.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['can-update-group']
    }
  },  
  {
    path: '/groups/add',
    name: 'addgroups',
    component: () => import('../views/Groups/addeditGroups.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['can-create-group']
    }  
  },
  {
    path: '/learningmaterial',
    name: 'learningmaterial',
    component: () => import('../views/Documents/Documents.vue'), 
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,6]
    }  
  },
  {
    path: '/vouchers',
    name: 'vouchers',
    component: () => import('../views/Vouchers/Vouchers.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    } 
  },
  {
    path: '/tutor-vouchers',
    name: 'tutorvouchers',
    component: () => import('../views/Vouchers/tutorVouchers.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    } 
  },
  {
    path: '/coupons',
    name: 'coupons',
    component: () => import('../views/Vouchers/Coupons.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    } 
  },
  {
    path: '/tutor-coupons',
    name: 'tutorcoupons',
    component: () => import('../views/Vouchers/tutorCoupons.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    } 
  },
  {
    path: '/courses',
    name: 'courses',
    component: () => import('../views/Courses/Courses.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,6]
    } 
  },
  {
    path: '/course/:id',
    name: 'coursedetails',
    component: () => import('../views/Courses/CourseDetail.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,6]
    } 
  },
  {
    path: '/drafts',
    name: 'drafts',
    component: () => import('../views/Drafts/Drafts.vue'),   
    meta: { 
      requiresAuth: true,
      allowedUsers:[5] //1
    }
  },
  {
    path: '/draftplayer/:id',
    name: 'draftplayer',
    component: () => import('../views/DraftPlayer/DraftPlayer.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[5] //1
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/Settings/Settings.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,5]
    }  
  },
  {
    path: '/learningmaterial/:id',
    name: 'learningmaterialdetail',
    component: () => import('../views/Documents/DocumentDetail.vue'), 
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,6]
    }  
  },  
  {
    path: '/invoices',
    name: 'invoices',
    component: () => import('../views/Users/Invoices.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,5]
    } 
  }, 
  {
    path: '/forgot-password',
    name: 'forgotpassword',
    component: () => import('../views/Login/ForgotPassword.vue'),
    meta: { 
      requiresAuth: false
    }
  },     
  {
    path: '/users/edit/:id',
    name: 'editusers',
    component: () => import('../views/Users/addeditUsers.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      allowedPermissions:['can-assign-custom-role','can-audit-user-history']
    }  
  },
  {
    path: '/users/view/:id',
    name: 'viewusers',
    component: () => import('../views/Users/viewUsers.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      allowedPermissions:['can-assign-custom-role','can-audit-user-history']
    }  
  },
  {
    path: '/ext-users/edit/:id',
    name: 'editextusers',
    component: () => import('../views/Users/addeditExtUsers.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      allowedPermissions:['can-assign-custom-role','can-audit-user-history'],
      has_external_users: true
    }  
  },
  {
    path: '/ext-users/view/:id',
    name: 'viewextusers',
    component: () => import('../views/Users/viewUsers.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      allowedPermissions:['can-assign-custom-role','can-audit-user-history']
    }  
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/Users/Profile.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,5,6]
    }  
  },  
  {
    path: '/users/add',
    name: 'addusers',
    component: () => import('../views/Users/addeditUsers.vue'), 
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      allowedPermissions:['can-assign-custom-role']
    }    
  }, 
  {
    path: '/ext-users/add',
    name: 'addextusers',
    component: () => import('../views/Users/addeditExtUsers.vue'), 
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3]
    }    
  },      
  {
    path: '/course/:courseId/moduleplayer/:id',
    name: 'moduleplayer',
    component: () => import('../views/ModulePlayer/ModulePlayer.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,6]
    }  
  },
 
  {
    path: '/pages/:slug',
    name: 'pages',
    component: () => import('../views/Pages/Pages.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,5,6]
    } 
  },  
  {
    path: '/reminder',
    name: 'reminder',
    component: () => import('../views/ReminderEmail/ReminderEmail.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['has-access-to-all-mail-types', 'has-access-to-reminder-mails']
    }  
  },  
  {
    path: '/reminder/add',
    name: 'addreminderemail',
    component: () => import('../views/ReminderEmail/addeditReminderEmail.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['has-access-to-all-mail-types', 'has-access-to-reminder-mails']
    }   
  },   
  {
    path: '/reminder/edit/:id',
    name: 'editreminderemail',
    component: () => import('../views/ReminderEmail/addeditReminderEmail.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['has-access-to-all-mail-types', 'has-access-to-reminder-mails']
    }   
  },   
  {
    path: '/system-email-template',
    name: 'customemailtemplate',
    component: () => import('../views/CustomEmail/CustomEmailTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['has-access-to-all-mail-types', 'has-access-to-system-mails']
    }  
  },  
  {
    path: '/system-email-template/add',
    name: 'addcustomemailtemplate',
    component: () => import('../views/CustomEmail/addeditCustomEmailTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['has-access-to-all-mail-types', 'has-access-to-system-mails']
    }   
  },   
  {
    path: '/system-email-template/edit/:id',
    name: 'editcustomemailtemplate',
    component: () => import('../views/CustomEmail/addeditCustomEmailTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['has-access-to-all-mail-types', 'has-access-to-system-mails']
    }   
  }, 
  {
    path: '/scheduled-mail-notification',
    name: 'scheduledmail',
    component: () => import('../views/ScheduledMail/ScheduledMail.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['has-access-to-all-mail-types', 'has-access-to-scheduled-mails']
    }  
  },  
  {
    path: '/scheduled-mail-notification/add',
    name: 'addscheduledmail',
    component: () => import('../views/ScheduledMail/addeditScheduledMail.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['has-access-to-all-mail-types', 'has-access-to-scheduled-mails']
    }   
  },   
  {
    path: '/scheduled-mail-notification/edit/:id',
    name: 'editscheduledmail',
    component: () => import('../views/ScheduledMail/addeditScheduledMail.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['has-access-to-all-mail-types', 'has-access-to-scheduled-mails']
    }   
  }, 
  {
    path: '/trigger-mail-template',
    name: 'triggeredmail',
    component: () => import('../views/TriggerMailTemplate/TriggerMailTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['has-access-to-all-mail-types', 'has-access-to-trigger-mails']
    }  
  },  
  {
    path: '/trigger-mail-template/add',
    name: 'addtriggeredmail',
    component: () => import('../views/TriggerMailTemplate/addeditTriggerMailTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['has-access-to-all-mail-types', 'has-access-to-trigger-mails']
    }   
  },   
  {
    path: '/trigger-mail-template/edit/:id',
    name: 'edittriggeredmail',
    component: () => import('../views/TriggerMailTemplate/addeditTriggerMailTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['has-access-to-all-mail-types', 'has-access-to-trigger-mails']
    }   
  }, 
  {
    path: '/equipment-group',
    name: 'equipmentgroup',
    component: () => import('../views/Equipments/EquipmentGroup/EquipmentGroup.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_equip_db: true,
      allowedPermissions:['can-create-equipment-group','can-update-equipment-group', 'can-delete-equipment-group']
    }  
  },  
  {
    path: '/equipment-group/add',
    name: 'addequipmentgroup',
    component: () => import('../views/Equipments/EquipmentGroup/addeditEquipmentGroup.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_equip_db: true,
      allowedPermissions:['can-create-equipment-group']
    } 
  },  
  {
    path: '/equipment-group/edit/:id',
    name: 'editequipmentgroup',
    component: () => import('../views/Equipments/EquipmentGroup/addeditEquipmentGroup.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_equip_db: true,
      allowedPermissions:['can-update-equipment-group']
    }  
  }, 
  {
    path: '/equipment-template',
    name: 'Calibrationtemplate',
    component: () => import('../views/Equipments/CalibrationTemplate/CalibrationTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_equip_db: true,
      allowedPermissions:['can-create-equipment-template','can-update-equipment-template', 'can-delete-equipment-template']
    } 
  },  
  {
    path: '/equipment-template/add',
    name: 'addCalibrationtemplate',
    component: () => import('../views/Equipments/CalibrationTemplate/addeditCalibrationTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_equip_db: true,
      allowedPermissions:['can-create-equipment-template']
    } 
  },  
  {
    path: '/equipment-template/edit/:id',
    name: 'editCalibrationtemplate',
    component: () => import('../views/Equipments/CalibrationTemplate/addeditCalibrationTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_equip_db: true,
      allowedPermissions:['can-update-equipment-template']
    }
  }, 
  {
    path: '/personal-template',
    name: 'personaltemplate',
    component: () => import('../views/Groups/PersonalTemplate/PersonalTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['can-create-personal-template','can-update-personal-template', 'can-delete-personal-template']
    }
  }, 
  {
    path: '/personal-template/add',
    name: 'addpersonaltemplate',
    component: () => import('../views/Groups/PersonalTemplate/addeditPersonalTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['can-create-personal-template']
    } 
  }, 
  {
    path: '/personal-template/edit/:id',
    name: 'editpersonaltemplate',
    component: () => import('../views/Groups/PersonalTemplate/addeditPersonalTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['can-update-personal-template']
    }
  }, 
  {
    path: '/task-center-group',
    name: 'testcasegroup',
    component: () => import('../views/TestCase/TestCaseGroup/TestCaseGroup.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_task_center: true,
      allowedPermissions:['can-create-test-case-group','can-update-test-case-group', 'can-delete-test-case-group']
    }
  }, 
  {
    path: '/task-center-group/add',
    name: 'addtestcasegroup',
    component: () => import('../views/TestCase/TestCaseGroup/addeditTestCaseGroup.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_task_center: true,
      allowedPermissions:['can-create-test-case-group']
    }
  }, 
  {
    path: '/task-center-group/edit/:id',
    name: 'edittestcasegroup',
    component: () => import('../views/TestCase/TestCaseGroup/addeditTestCaseGroup.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['can-update-test-case-group']
    }
  }, 
  {
    path: '/task-center-template',
    name: 'testcasetemplate',
    component: () => import('../views/TestCase/TestCaseTemplate/TestCaseTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_task_center: true,
      allowedPermissions:['can-create-test-case-template','can-update-test-case-template', 'can-delete-test-case-template']
    }
  },
  {
    path: '/task-center-template/add',
    name: 'addtestcasetemplate',
    component: () => import('../views/TestCase/TestCaseTemplate/addeditTestCaseTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['can-create-test-case-template']
    } 
  }, 
  {
    path: '/task-center-template/edit/:id',
    name: 'edittestcasetemplate',
    component: () => import('../views/TestCase/TestCaseTemplate/addeditTestCaseTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_task_center: true,
      allowedPermissions:['can-update-test-case-template']
    }
  }, 
  {
    path: '/task-center/',
    name: 'testcase',
    component: () => import('../views/TestCase/TestCase.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      has_task_center: true,
      allowedPermissions:['can-create-test-case','can-update-test-case', 'can-delete-test-case']
    }
  },   
  {
    path: '/task-center/add',
    name: 'testcaseadd',
    component: () => import('../views/TestCase/addeditTestCase.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      has_task_center: true,
      allowedPermissions:['can-create-test-case']
    } 
  }, 
  {
    path: '/task-center/edit/:id',
    name: 'testcaseedit',
    component: () => import('../views/TestCase/addeditTestCase.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      has_task_center: true,
      allowedPermissions:['can-update-test-case']
    }
  }, 
  {
    path: '/questions/',
    name: 'questions',
    component: () => import('../views/Tests/Questions/Questions.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['can-create-question','can-update-question','can-delete-question'],
    }
  }, 
  {
    path: '/questions/add/',
    name: 'questionadd',
    component: () => import('../views/Tests/Questions/addeditQuestions.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['can-create-question'],
    }
  },
  {
    path: '/questions/edit/:id',
    name: 'questionedit',
    component: () => import('../views/Tests/Questions/addeditQuestions.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['can-update-question'],
    }
  }, 
  {
    path: '/quiz/',
    name: 'quiz',
    component: () => import('../views/Tests/Quiz/Quiz.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['can-create-quiz','can-update-quiz','can-delete-quiz']
    }
  },  
  {
    path: '/quiz/add/',
    name: 'quizadd',
    component: () => import('../views/Tests/Quiz/addeditQuiz.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['can-create-quiz']
    }
  },
  {
    path: '/quiz/edit/:id',
    name: 'quizedit',
    component: () => import('../views/Tests/Quiz/addeditQuiz.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['can-update-quiz']
    }
  }, 
  {
    path: '/test-center/',
    name: 'testcenter',
    component: () => import('../views/Tests/TestCenter/testCenter.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,6]
    }
  },  
  {
    path: '/companypages/:slug',
    name: 'companypages',
    component: () => import('../views/AdditionalPages/CompanyPage.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,5,6]
    } 
  },  
  {
    path: '/resources',
    name: 'resources',
    component: () => import('../views/AdditionalPages/resources.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['has-access-to-additional-pages-resource']
    }
  },  
  {
    path: '/resources/add/',
    name: 'resourcesadd',
    component: () => import('../views/AdditionalPages/addeditresources.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['has-access-to-additional-pages-resource']
    }
  },
  {
    path: '/additional-pages/',
    name: 'additionalpages',
    component: () => import('../views/AdditionalPages/AdditionalPages.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['has-access-to-additional-pages']
    }
  },  
  {
    path: '/additional-pages/add/',
    name: 'additionalpagesadd',
    component: () => import('../views/AdditionalPages/addeditAdditionalPages.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['has-access-to-additional-pages']
    }
  },
  {
    path: '/additional-pages/edit/:id',
    name: 'additionalpagesedit',
    component: () => import('../views/AdditionalPages/addeditAdditionalPages.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      allowedPermissions:['has-access-to-additional-pages']
    }
  },  
  {
    path: '/custom-role',
    name: 'customrole',
    component: () => import('../views/CustomRole/CustomRole.vue'), 
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      allowedPermissions:['can-create-custom-role','can-update-custom-role','can-delete-custom-role']
    }  
  },  
  {
    path: '/custom-role/add/',
    name: 'customroleadd',
    component: () => import('../views/CustomRole/addeditCustomRole.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      allowedPermissions:['can-create-custom-role']
    }
  }, 
  {
    path: '/custom-role/edit/:id',
    name: 'customroleedit',
    component: () => import('../views/CustomRole/addeditCustomRole.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      allowedPermissions:['can-update-custom-role']
    }
  }, 
  {
    path: '/coursesstats/',
    name: 'coursesstats',
    component: () => import('../views/Statistics/CourseStats.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      allowedPermissions:['has-access-to-all-statistics', 'has-access-to-course-statistics']
    }
  }, 
  {
    path: '/userstats/',
    name: 'userstats',
    component: () => import('../views/Statistics/UserStats.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      allowedPermissions:['has-access-to-all-statistics', 'has-access-to-course-statistics']
    }
  }, 
  {
    path: '/groupstats/',
    name: 'groupstats',
    component: () => import('../views/Statistics/GroupStats.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      allowedPermissions:['has-access-to-all-statistics', 'has-access-to-group-statistics']
    }
  },  
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
    if(store.getters.isAuthenticated){
      if (JwtService.getToken()) {
        ApiService.setHeader();
        store.commit(SET_ROUTER_ENTER, true)
        store.commit(SET_LOGGED_IN, true)
      }

    let permissionStatus = to.meta.hasOwnProperty('allowedPermissions') ? to.meta.allowedPermissions.some(o => store.getters.currentUser.permissions.includes(o)) : false
    let roleStatus = to.meta.hasOwnProperty('allowedUsers') ? to.meta.allowedUsers.some(o => store.getters.currentUser.roles.includes(o)) : false
    // let permissionStatus = true;
    // let roleStatus = true;
    
    if(!to.meta.requiresAuth)
      next()
    else if(to.meta.requiresAuth && (!store.getters.isAuthenticated || (!roleStatus && !permissionStatus) ))
      next({ name: 'login' })
    else if (to.meta.hasOwnProperty('has_task_center') && JSON.parse(store.getters.currentUser.company.company_meta).has_task_center == 'false')
      next({ name: 'login' })
    else if (to.meta.hasOwnProperty('has_equip_db') && JSON.parse(store.getters.currentUser.company.company_meta).has_equip_db == 'false')
      next({ name: 'login' })
    else next()    
  }
  else{
    if(to.meta.requiresAuth && !store.getters.isAuthenticated){
      next({ name: 'login' })
    }
    next()
  }


})



export default router
